_.mixin({
    diffObject : function(a,b) {
       var diff = {};

       _.each(a,function(value, key) {
           var inner;

           if (_.isPlainObject(value)) {
                if (!_.isPlainObject(b[key]))  {
                    diff[key] = value;
                } else {
                    inner = _.objectDiff(value, b[key]);
                    if (!_.isPlainObject(inner) || !_.isEmpty(inner)) diff[key] = inner;
                }
           } else if (!_.isEqual(value, b[key])) {
                diff[key] = value;
           }
       });

       return _.cloneDeep(diff);
    },
    tidy: function(obj) {
        _.each(obj, function(value, key) {
            if (value == null || _.isPlainObject(value) && _.isEmpty(_.tidy(value))) {
               delete obj[key];
            }
        });

        return obj;
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/vendor/lodash.mixins.js
 ** module id = 1200
 ** module chunks = 10
 **/